"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventTypeImportOpenApiOutData = void 0;
class EventTypeImportOpenApiOutData {
    constructor() {
    }
    static getAttributeTypeMap() {
        return EventTypeImportOpenApiOutData.attributeTypeMap;
    }
}
exports.EventTypeImportOpenApiOutData = EventTypeImportOpenApiOutData;
EventTypeImportOpenApiOutData.discriminator = undefined;
EventTypeImportOpenApiOutData.attributeTypeMap = [
    {
        "name": "modified",
        "baseName": "modified",
        "type": "Array<string>",
        "format": ""
    }
];
//# sourceMappingURL=EventTypeImportOpenApiOutData.js.map